export default __webpack_public_path__ + "static/media/glasses5.efd2923b.jpeg";